<!-- 老人健康数据 -->
<template>
	<div class="main" style="width: 1200px; margin-top: 30px; padding-bottom: 50px;">
		<a-spin :spinning="spinning" tip="加载中" :delay="100">
			<!-- <HealthTop ref="healthTop" /> -->
			<!-- <homeTopTwo ref="homeTopTwo" /> -->
			<a-card style="background: #ECF0F3; box-shadow: 10px 10px 30px 0px #D1D9E6, -10px -10px 30px 0px #FFFFFF; border-radius: 20px; min-height: 700px;">
				<div class="health-title">
					<div v-if="!isSearch" class="title">用户个人睡眠数据</div>
					<div v-if="isSearch" style="display: flex; align-items: center">
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 500; font-size: 18px; color: rgba(31, 38, 53, 1); line-height: 24px;">关于“{{ searchText }}</div>
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 500; font-size: 18px; color: rgba(31, 38, 53, 1); line-height: 24px;">”共搜索到</div>
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 500; font-size: 18px; color: rgba(74, 124, 232, 1); line-height: 24px;">{{ total }}</div>
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 500; font-size: 18px; color: rgba(31, 38, 53, 1); line-height: 24px;">条记录</div>
						<div style="width: 66px; height: 30px; background: rgba(74, 124, 232, 0.15); border-radius: 20px; display: flex; align-items: center; margin-left: 10px; cursor: pointer;" @click="searchBack">
							<img style="width: 16px; height: 16px; margin-left: 5px; margin-right: 2px; margin-left: 10px;" src="../../assets/icon_health_data_back_icon.png" alt="" />
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #497AE5; line-height: 20px;">返回</div>
						</div>
					</div>
					<div v-if="!isSearch" style="display: flex;">
						<router-link target="_blank" :to="{ path: '/dean/dataSummary', params: { id: '8' } }">
							<div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
								<QlBtnA :text="'当日数据汇总'" />
							</div>
						</router-link>
						<router-link style="margin-left:10px;" target="_blank" :to="{ path: '/dean/dataView', params: { id: '8' } }">
							<div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
								<QlBtnA :text="'累计数据查看'" />
							</div>
						</router-link>
					</div>
				</div>
				<div style="height: 12px; border-bottom: 1px solid rgba(31, 38, 53, 0.05); margin-bottom: 15px;"></div>
				<div v-if="!isSearch" class="topList">
					<div class="topleft">
						<div class="group">
							<div class="title">楼</div>
							<a-select :class="['my-a-select', oldSelectFloorIndex != newSelectFloorIndex ? 'my-a-select-high-light' : 'my-a-select-normal']" v-model="floorVal" @change="floorChange" style="width: 130px;">
								<a-select-option v-for="(item, index) in floorData" :key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</div>
						<div class="group">
							<div class="title">层</div>
							<a-select :class="['my-a-select', oldSelectLayerIndex != newSelectLayerIndex ? 'my-a-select-high-light' : 'my-a-select-normal']" v-model="layerVal" @change="layerChange" style="width: 130px">
								<a-select-option v-for="(item, index) in layerData" :key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</div>
						<div class="group">
							<div class="title">房</div>
							<a-select :class="['my-a-select', oldSelectRoomIndex != newSelectRoomIndex ? 'my-a-select-high-light' : 'my-a-select-normal']" v-model="roomVal" @change="roomChange" style="width: 130px">
								<a-select-option v-for="(item, index) in roomData" :key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</div>
						<QlBtn :text="'筛选'" @btnClick="screen" :width="'86px'" />
					</div>
					<div class="topright">
						<!-- <a-select
            default-value="1"
            style="width: 120px; margin-right: 10px"
            size="default"
            @change="handleChange"
          >
            <a-select-option value="1"> 按列表查看 </a-select-option>
            <a-select-option value="2"> 按单人查看 </a-select-option>
          </a-select>
          <div
            class="hoverBtns on"
            @click="exportData"
            v-if="healthBigData[3].enable == 1"
          >
            导出表格
          </div> -->
						<div class="saiBtn">
							<!-- <a-popover v-model="showCalendar">
								<template slot="content">
									<a-calendar :fullscreen="false" :defaultValue="$moment(activeDate, 'YYYY-MM-DD')"
										:value="$moment(activeDate, 'YYYY-MM-DD')" :validRange="[
											$moment(activeDates[activeDates.length - 1], 'YYYY-MM-DD'),
											$moment(activeDates[0], 'YYYY-MM-DD'),
										]" @panelChange="panelChange" @select="changeDate">
										<template slot="dateCellRender" slot-scope="value">
											<div v-if="getDayData(value)">
												<section>
													<div class="calDot"></div>
												</section>
											</div>
										</template>
									</a-calendar>
								</template>
								<a-button class="button-date" style="background:#E6F7FF;border: none;color: #1890FF;">
									{{ activeDate.slice(5, 7) + '月' + activeDate.slice(8) + '日' }}
									<a-icon type="calendar" />
								</a-button>
							</a-popover>
							&nbsp; &nbsp; -->
							<div :class="['searchBedNameInputContent',  searchInputIsHover ? 'searchBedNameInputContent_hover': '', searchInputIsEdit ? 'searchBedNameInputContent_edit' : '']" style="display: flex; padding-left: 15px; padding-right: 15px; align-items: center; border-radius: 20px; margin-right: 15px;" :style="{ border: '1px solid rgba(94,103,121,0.2)' }"  @mouseenter="mouseenter" @mouseleave="mouseleave">
								<input
									id="healthDataSearchInput"
									class="searchBedNameInput"
									style="width: 120px; border: none; outline: none; background: #FFFFFF00; caret-color: rgba(74, 124, 232, 1); color: rgba(94, 103, 121, 1)"
									v-model="searchText"
									placeholder="请输入床位名称"
									v-on:focus="inputFocus"
									v-on:blur="inputBlur"
									autocomplete="off"
									@keyup.enter="beginSearch"
								/>
								<div :class="['searchBedNameInputContentSearchImage']" style="width: 16px; height: 16px; margin-left: 5px;" :style="{ cursor: searchText && searchText.length > 0 ? 'pointer' : 'unset' }" @click="beginSearch"></div>
								<!-- <img style="width: 16px; height: 16px; margin-left: 5px;" src="../../assets/icon_common_share_1.png" alt="" /> -->
							</div>
							<div 
							:class="['my-select-date', this.selectDateType == '1' ? 'my-select-date-2' : 'my-select-date-1']"
							style="display: flex; position: relative;">
								<div :class="'my-select-date-input'" style="display: flex; display: flex; align-items: center; border-radius: 20px; padding: 0px 15px; margin-right: 15px;">
									<div
									class="my-select-date-input-text"
									style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px;">{{ showActiveDate }}</div>
									<div 
									class="my-select-date-input-img"
									style="width: 16px; height: 16px; margin-left: 10px;" 
									>
									</div>
								</div>
								<el-date-picker
								class="my-el-date-picker"
								v-model="activeDate"
								type="date"
								placeholder="选择日期"
								style="position: absolute; width: 100%; height: 100%; opacity: 0; left: 0px;"
								value-format="yyyy-MM-dd"
								@change="changeNewDate"
								popper-class="my-el-date-picker-popper"
								:picker-options="pickerOptions"
								:clearable="false"
								>
								</el-date-picker>
							</div>
							<div v-for="(item, index) in btnList2" :key="index" @click="btnClickNew(item.val, activeDate, 1, item.val == 3 ? '7' : '30')"
								:title="item.placeholder" class="hoverBtns on dateBtn" :class="{ actives: activeType == item.val }">
								{{ item.title }}
							</div>
						</div>
					</div>
				</div>
				<div class="health-list" v-show="selectValue == 2">
					<HealthList ref="healthList" />
				</div>
				<!-- <div style="width:100%;text-align: center;">
        <a-spin :spinning="tableSpinning" tip="加载中" :delay="100" size="large">
          <div v-if="!tableSpinning"> -->
				<div v-if="total > 0 && selectValue == 1 && healthBigData[3].enable == 1">
					<a-table :columns="columns" :data-source="tableData" bordered :pagination="false" rowKey="bedId"
						@change="onchange">
						<!-- <span slot="AHI">
                  AHI
                  <a-popover placement="bottom" overlayClassName="breath-popover">
                    <template slot="content">
                      <p>AHI是医学上用于确定呼吸暂停严重</p>
                      <p>程度的重要指标，AHI医学评级标准：</p>
                      <p>{{ string }} 为健康</p>
                      <p>{{ string1 }} 疑似低风险</p>
                      <p>{{ string2 }} 疑似中风险</p>
                      <p>AHI≥30 疑似高风险</p>
                    </template>
                    <div class="question-icon">?</div>
                  </a-popover>
                </span> -->
						<template slot="operation" slot-scope="scope">
							<div class="operation">
								<span @click="details(scope)" class="tableBtn">查看</span>
								<span class="share">
									<a-popover placement="bottomLeft" destroyTooltipOnHide trigger="click" v-model="scope.popoverVisible">
										<template slot="content">
											<div class="shareBox">
												<div id="qrCode" ref="qrCodeDiv"></div>
												<p>
													<a-icon type="wechat" style="color: #09bb07; font-size: 22px" />
													<span>微信扫一扫</span>
												</p>
											</div>
										</template>
										<img src="../../assets/icon_common_share_1.png" class="imgIcon" alt="" v-preventReClick
											@click="shareBtn(scope)" />
									</a-popover>
								</span>
							</div>
						</template>
						<template slot="szhx" slot-scope="scope">
							<div class="operation">
								<span @click="openSee(scope)" class="tableBtn">查看</span>
							</div>
						</template>
					</a-table>
				</div>

				<!-- <a-empty v-if="total == 0 && selectValue == 1 && healthBigData[3].enable == 1" /> -->
				<div v-if="total == 0 && selectValue == 1 && healthBigData[3].enable == 1" style="height: 500px; display: flex; align-items: center; flex-direction: column; justify-content: center;">
					<img style="width: 107px; height: 107px;" src="../../assets/icon_common_empty_icon_new.png" alt="" />
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #A4ABB6; line-height: 20px; margin-top: 15px;">暂无内容</div>
				</div>
				<div style="margin-bottom: 25px;">
					<a-pagination v-model="pageNum" @change="pageChange" :total="total" :pageSize="pageSize" :hideOnSinglePage="true"
					show-less-items style="text-align: center; margin-top: 20px" v-if="healthBigData[3].enable == 1" />
				</div>
				<div class="table-empty" v-if="healthBigData[3].enable != 1">
					暂未订购
				</div>
				<!-- </div>
        </a-spin>
      </div> -->

			</a-card>
			<!-- 查看 -->
			<Healthy ref="healthy" />



			<!-- 弹窗_数字画像 -->
			<tan_needGz_portrait ref="tan_needGz_portrait"></tan_needGz_portrait>

			<!-- 弹窗_关注老人单人详情 -->
			<tan_needGz_sin ref="tan_needGz_sin"></tan_needGz_sin>

		</a-spin>
	</div>
</template>

<script>
import QRCode from 'qrcodejs2';
import Healthy from '../../component/healthy/healthy.vue';
import HealthTop from './component/healthTop';
import homeTopTwo from './component/homeTopTwo';
import HealthList from './component/healthList';
import tan_needGz_portrait from './component/tan_needGz_portrait.vue';        //弹窗_数字画像
import tan_needGz_sin from './component/tan_needGz_sin.vue';                  //弹窗_关注老人单人详情
import QlBtn from '../../component/common/qlBtn.vue'
import QlBtnA from '../../component/common/qlBtnA.vue'


const columns = [
	{
		title: '床位',
		dataIndex: 'bedName',
		width: "216px",
		align: 'center',
		sorter: (a, b) => 0,
		sortOrder: false,
		index: '0',
	},
	{
		title: '睡眠得分',
		dataIndex: 'score',
		width: "96px",
		align: 'center',
		sorter: (a, b) => 0,
		index: '1',
	},
	{
		title: '睡眠时长',
		dataIndex: 'sleepDuration',
		width: "100px",
		align: 'center',
		sorter: (a, b) => 0,
		index: '2',
	},
	{
		title: '睡眠效率',
		dataIndex: 'sleepEff',
		width: "96px",
		align: 'center',
		sorter: (a, b) => 0,
		index: '3',
	},
	// {
	//     title: '深睡时长',
	//     dataIndex: 'deepSleepDuration',
	//     width: '10%',
	//     align: 'center',
	// },
	// {
	//     title: '浅睡时长',
	//     dataIndex: 'lightSleepDuration',
	//     width: '10%',
	//     align: 'center',
	// },
	// {
	//     title: '清醒时长',
	//     dataIndex: 'clearSleepDuration',
	//     width: '10%',
	//     align: 'center',
	// },
	{
		title: '离床时长',
		dataIndex: 'outBedDuration',
		width: "96px",
		align: 'center',
		index: '4',
		sorter: (a, b) => 0,
	},
	{
		title: '睡眠间离床次数',
		dataIndex: 'outBedNum',
		width: "96px",
		align: 'center',
		index: '5',
		sorter: (a, b) => 0,
	},
	{
		title: '体动指数',
		dataIndex: 'turnOverIndex',
		width: "96px",
		align: 'center',
		index: '6',
		sorter: (a, b) => 0,
	},
	// {
	//   title: '异常指标',
	//   // slots: { title: 'AHI' },
	//   dataIndex: 'anomalyIndex',
	//   // width: "15%",
	//   align: 'center',
	//   index: '7',
	//   sorter: (a, b) => 0,
	// },
	{
		title: '呼吸异常指数',
		// slots: { title: 'AHI' },
		dataIndex: 'ahi',
		width: "96px",
		align: 'center',
		index: '7',
		sorter: (a, b) => 0,
	},
	{
		title: '需关注的变化',
		// slots: { title: 'AHI' },
		dataIndex: 'followTotal',
		width: "96px",
		align: 'center',
		index: '8',
		sorter: (a, b) => 0,
	},
	{
		title: '睡眠报告',
		align: 'center',
		key: 'operation',
		scopedSlots: { customRender: 'operation' },
		width: '86px'
	},
	{
		title: '数字画像',
		align: 'center',
		key: 'szhx',
		scopedSlots: { customRender: 'szhx' },
		width: '86px'
	},
];
const morecolumns = [
	{
		title: '床位',
		dataIndex: 'bedName',
		//width: "12%",
		align: 'center',
		index: '0',
		sortOrder: false,
		sorter: (a, b) => 0,
		width: '280px',
	},
	{
		title: '睡眠时长',
		dataIndex: 'sleepDuration',
		// width: "12%",
		align: 'center',
		index: '1',
		sortOrder: false,
		sorter: (a, b) => 0,
	},
	{
		title: '离床时长',
		dataIndex: 'outBedDuration',
		//width: "12%",
		align: 'center',
		index: '2',
		sortOrder: false,
		sorter: (a, b) => 0,
	},
	{
		title: '睡眠间离床次数',
		dataIndex: 'outBedNum',
		// width: "15%",
		align: 'center',
		index: '3',
		sortOrder: false,
		sorter: (a, b) => 0,
	},
	{
		title: '体动次数',
		dataIndex: 'turnOverNum',
		//width: "15%",
		align: 'center',
		index: '4',
		sortOrder: false,
		sorter: (a, b) => 0,
	},
	{
		title: '需关注的变化',
		// slots: { title: 'AHI' },
		dataIndex: 'followTotal',
		// width: "15%",
		align: 'center',
		index: '5',
		sorter: (a, b) => 0,
	},
	{
		title: '睡眠报告',
		align: 'center',
		key: 'operation',
		scopedSlots: { customRender: 'operation' },
	},
];
export default {
	components: { Healthy, HealthTop, HealthList, homeTopTwo, tan_needGz_portrait, tan_needGz_sin, QlBtn, QlBtnA },
	data() {
		return {
			tableSpinning: true,
			showCalendar: false,
			string: '指数<5',
			string1: '5≤指数<15',
			string2: '15≤指数<30 ',
			beginTime: '',
			endTime: '',
			columns: columns,
			pageNum: 1, // 当前页
			pageSize: 20, // 每页默认20条
			total: 0,
			tableData: [],
			floorVal: '全部', // 楼
			floorData: [], // 楼下拉框数据
			layerVal: '全部', // 层
			layerData: [], // 层下拉框数据
			roomVal: '全部', // 房间
			roomData: [], // 房间下拉框数据
			loading: false,
			spinning: true,
			btnList: [
				// 筛选列表
				{
					val: 1,
					title: '昨天',
					placeholder: '呈现昨天数据分析结果',
				},
				{
					val: 2,
					title: '前天',
					placeholder: '呈现前天数据分析结果',
				},
				{
					val: 3,
					title: '过去7天',
					placeholder: '呈现过去7天数据分析结果',
				},
				{
					val: 4,
					title: '过去30天',
					placeholder: '呈现过去30天数据分析结果',
				},
			],
			btnList2: [
				// 筛选列表
				{
					val: 3,
					title: '过去7天',
					placeholder: '呈现过去7天数据分析结果',
				},
				{
					val: 4,
					title: '过去30天',
					placeholder: '呈现过去30天数据分析结果',
				},
			],
			btnList3: [
				// 筛选列表
				{
					val: 5,
					path: 'dataSummary',
					title: '当日数据汇总',
				},
				{
					val: 6,
					path: 'dataView',
					title: '累计数据查看',
				},
			],
			activeType: 1, // 默认今天
			detailsPopup: false, // 查看弹窗状态
			popoverVisible: false,
			dataTitleList: [
				{
					name: '睡眠时长',
					img: require('../../assets/icon_SleepTime_36.png'),
					time: 10,
					num: 23,
					type: 1,
				},
				{
					name: '体动次数',
					img: require('../../assets/icon_SleepTurn_36.png'),
					num: 23,
					type: 2,
				},
				{
					name: '离床时长',
					img: require('../../assets/icon_SleepLeaveTime_36.png'),
					time: 10,
					num: 23,
					type: 1,
				},
				{
					name: '离床次数',
					img: require('../../assets/icon_SleepLeave_36.png'),
					num: 23,
					type: 2,
				},

				{
					name: '睡眠呼吸',
					img: require('../../assets/icon_SleepLeaveTime_36.png'),
					time: 10,
					num: 23,
					type: 2,
				},
			],
			myChart1: null,
			myChart2: null,
			myChart3: null,
			myChart4: null,
			myChart5: null,
			myChart6: null,
			myChart7: null,
			myChart8: null,
			myChart9: null,
			myChartAHI: null,
			detailsData: {}, // 详情单天数据
			detailsManyData: {}, // 详情多天 数据
			bedName: '', // 床名称
			sleepDetails: [], // 睡眠详情数据
			shareUrl: '', // 分享参数
			sortField: 'score',
			sortOrder: 'descend',
			disabled: false,
			loading1: true,
			popoverTop: null,
			scrollTop: 0,
			selectValue: 1,
			activeDate: '',
			activeDates: [],
			healthBigData: [
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
			],
			effeDatesData: null,
			effeDates: [],
			selectDateType: '1',
			
			oldSelectFloorIndex: 0,
			oldSelectLayerIndex: 0,
			oldSelectRoomIndex: 0,

			newSelectFloorIndex: 0,
			newSelectLayerIndex: 0,
			newSelectRoomIndex: 0,
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
			showActiveDate: '',


			searchText: null,
			searchInputIsHover: false,
			searchInputIsEdit: false,
			isSearch: false

		};
	},
	created() {
	},
	mounted() {
		this.getHealthBigData();
		this.getActiveDates();
		this.activeDate = this.activeDates[0];
		this.getTableData();
		// 获取楼下拉框数据
		this.$get(
			'/api/building/allBuilding',
			{},
			(res) => {
				if (res.code == 0) {
					res.data[0].id = '';
					this.floorData = res.data;
				} else {
					this.$message.error(res.msg);
					this.floorData = [];
				}
			},
			(err) => {
				console.log(err);
				this.$message.error('服务端发生异常');
			}
		);
		this.getHealthPageV1All();
	},
	watch: {
		activeDate(newVal,oldVal){
			if (newVal == '' || !newVal) {
				
			} else {
				this.showActiveDate = this.activeDate.slice(5, 7) + '月' + this.activeDate.slice(8) + '日'
			}
		}
	},
	methods: {
		searchBack() {
			this.searchInputIsHover = false;
			this.searchInputIsEdit = false;
			this.isSearch = false;
			this.searchText = "";
			this.pageNum = 1;
            this.getTableData();
		},
		beginSearch() {
			if (this.searchText && this.searchText.length > 0) {
				this.isSearch = true;
			} else {
				this.isSearch = false;
			}
			this.pageNum = 1;
            this.getTableData();
		},
		inputFocus(e) {
			console.log('===搜索框编辑中===')
			this.searchInputIsEdit = true;
		},
		inputBlur(e) {
			console.log('===搜索框取消编辑===')
			this.searchInputIsEdit = false;
		},
		mouseenter(e) {
			console.log('===hover===')
			this.searchInputIsHover = true;
		},
		mouseleave() {
			console.log('===取消hover===')
			this.searchInputIsHover = false;
		},
		openSee(data) {
			this.$refs.tan_needGz_portrait.openComponent_tan_needGz_portrait(data)
		},
		disabledDate(date) {
			let today = new Date(); //当天
			today.setFullYear(today.getFullYear() - 1);
			return (
				date > this.$moment(this.$moment(new Date()).format('YYYY-MM-DD')) ||
				date < this.$moment(this.$moment(today).format('YYYY-MM-DD'))
			);
		},
		getHealthBigData() {
			this.$post(
				'api/health-big-data/select',
				{
					tenantId: this.$getCookie('userInfo').user.tenantId,
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.healthBigData = res.data;
							if (this.healthBigData[0].enable != 1) {
								this.$router.replace('/dean/home');
							} else {
							}
						} else {
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		handleChange(value) {
			console.log(`selected ${value}`);
			this.selectValue = value;
			this.pageNum = 1;
			this.getTableData();
		},
		changeTotal(total, pageSize) {
			this.total = total;
			this.pageSize = pageSize;
		},
		getActiveDates() {
			var day = new Date();
			var time = day.getTime();
			for (var i = 0; i <= 365; i++) {
				var ms = 24 * 3600 * 1000 * i;
				day.setTime(parseInt(time - ms));
				var y = day.getFullYear().toString();
				var m = (day.getMonth() + 1).toString();
				if (m.length <= 1) m = '0' + m;
				var d = day.getDate().toString();
				if (d.length <= 1) d = '0' + d;
				this.activeDates[i] = y + '-' + m + '-' + d;
			}
			// console.log(this.activeDates);
		},
		changeDates(value) {
			this.btnClick(1, this.activeDates[value], 2);
		},
		panelChange(date) {
			var dd = date._d;
			var y = dd.getFullYear().toString();
			var m = (dd.getMonth() + 1).toString();
			if (m.length <= 1) m = '0' + m;
			var d = dd.getDate().toString();
			if (d.length <= 1) d = '0' + d;
			var ad = y + '-' + m + '-' + d;
			//console.log(ad);
			if (this.activeDates.indexOf(ad) == -1) {
				var adn = ad;
				adn = parseInt(adn.split('-').join(''));
				var adsn = this.activeDate;
				adsn = parseInt(adsn.split('-').join(''));
				if (adn > adsn) this.btnClick(1, this.activeDates[0], 2);
				else this.btnClick(1, this.activeDates[this.activeDates.length - 1], 2);
			} else {
				this.btnClick(1, ad, 2);
			}
		},
		changeDate(date) {
			var dd = date._d;
			var y = dd.getFullYear().toString();
			var m = (dd.getMonth() + 1).toString();
			if (m.length <= 1) m = '0' + m;
			var d = dd.getDate().toString();
			if (d.length <= 1) d = '0' + d;
			var ad = y + '-' + m + '-' + d;
			//console.log(ad);
			this.btnClick(1, ad, 2);
		},
		changeNewDate(date) {
			this.btnClick(1, date, 2, '1');
		},
		AHI() {
			return (
				<span slot="AHI">
					呼吸异常指数
					<a-popover placement="bottom" overlayClassName="breath-popover">
						<template slot="content">
							<p>呼吸异常指数是医学上用于确定</p>
							<p>确定呼吸异常严重程度的重要指</p>
							<p>标，是指平均每小时睡眠中出现</p>
							<p>呼吸暂停+低通气的次数。</p>
						</template>

						<a-icon
							type="question-circle"
							style="color:#08c;font-size:16px;margin:5px"
						/>
					</a-popover>
				</span>
			);
		},
		AI() {
			return (
				<span slot="AHI">
					呼吸暂停指数(AI)
					<a-popover placement="bottom" overlayClassName="breath-popover">
						<template slot="content">
							<p>呼吸暂停指数是医学上用于确定</p>
							<p>确定呼吸异常严重程度的重要指</p>
							<p>标，是指平均每小时睡眠中出现</p>
							<p>呼吸暂停的次数。</p>
						</template>

						<a-icon
							type="question-circle"
							style="color:#08c;font-size:16px;margin:5px"
						/>
					</a-popover>
				</span>
			);
		},
		HI() {
			return (
				<span slot="AHI">
					低通气指数(HI)
					<a-popover placement="bottom" overlayClassName="breath-popover">
						<template slot="content">
							<p>低通气指数是医学上用于确定</p>
							<p>确定呼吸异常严重程度的重要指</p>
							<p>标，是指平均每小时睡眠中出现</p>
							<p>低通气的次数。</p>
						</template>

						<a-icon
							type="question-circle"
							style="color:#08c;font-size:16px;margin:5px"
						/>
					</a-popover>
				</span>
			);
		},
		checkscroll(event) {
			//console.log("###", event);
		},
		onchange(pagination, filters, sorter) {
			console.log('params', pagination, filters, sorter);
			var index = '0';

			if (this.activeType == '1' || this.activeType == '2') {
				switch (sorter.field) {
					case 'bedName':
						index = '0';
						break;
					case 'score':
						index = '1';
						break;
					case 'sleepDuration':
						index = '2';
						break;
					case 'sleepEff':
						index = '3';
						break;
					case 'outBedDuration':
						index = '4';
						break;
					case 'outBedNum':
						index = '5';
						break;
					case 'turnOverIndex':
						index = '6';
						break;
					case 'ahi':
						index = '7';
						break;
					case 'followTotal':
						index = '8';
						break;
				}
				for (let i = 0; i < 8; i++) {
					if (index != i) {
						this.columns[i].sortOrder = false;
					}
				}
			} else {
				switch (sorter.field) {
					case 'bedName':
						index = '0';
						break;

					case 'sleepDuration':
						index = '1';
						break;
					case 'outBedDuration':
						index = '2';
						break;
					case 'outBedNum':
						index = '3';
						break;
					case 'turnOverNum':
						index = '4';
						break;
					case 'followTotal':
						index = '5';
						break;
				}
				for (let i = 0; i < 6; i++) {
					if (index != i) {
						this.columns[i].sortOrder = false;
					}
				}
			}

			if (!this.columns[index].sortOrder || this.columns[index].sortOrder == 'ascend') {
				this.columns[index].sortOrder = 'descend';
				this.sortField = sorter.field;
				this.sortOrder = 'descend';
			} else {
				this.columns[index].sortOrder = 'ascend';
				this.sortField = sorter.field;
				this.sortOrder = 'ascend';
			}
			this.pageNum = 1;
			this.getTableData();
		},
		// 获取表格数据
		getTableData() {
			this.oldSelectFloorIndex = this.newSelectFloorIndex;
			this.oldSelectLayerIndex = this.newSelectLayerIndex;
			this.oldSelectRoomIndex = this.newSelectRoomIndex;


			var self = this;
			if (this.selectValue == 2) {
				let param = {
					pageNum: this.pageNum, // 当前页
					pageSize: 5, // 每页默认20条
					type: this.activeType, // 日期
					buildingId: this.floorVal, // 楼id
					floorId: this.layerVal == '全部' ? '' : this.layerVal, // 层id
					roomId: this.roomVal == '全部' ? '' : this.roomVal, // 房间id
					sortField: '',
					sortOrder: '',
				};
				this.$refs.healthList.getData(this.activeType, param);
				return;
			}
			this.pageSize = 20;
			var st = '';
			if (this.activeType == 1 || this.activeType == 2) st = this.activeDate;
			// else if (this.activeType == 3) st = this.activeDates[6];
			else if (this.activeType == 3) st = this.activeDates[6];
			else st = this.activeDates[29];

			let needDate;
			if (this.activeType > 1) {
				var today = new Date();
				var year = today.getFullYear();
				var month = ('0' + (today.getMonth() + 1)).slice(-2);
				var day = ('0' + today.getDate()).slice(-2);
				var date = year + '-' + month + '-' + day;
				needDate = date;
			} else {
				needDate = this.activeDate;
			}

			let param = {
				pageNum: this.pageNum, // 当前页
				pageSize: this.pageSize, // 每页默认20条
				// type: this.activeType, // 日期
				startTime: st,
				endTime: needDate,
				buildingId: (this.floorVal == '全部' || this.floorVal == 0) ? '' : this.floorData[this.floorVal].id, // 楼id
				floorId: (this.layerVal == '全部' || this.layerVal == 0) ? '' : this.layerData[this.layerVal].id, // 层id
				roomId: (this.roomVal == '全部' || this.roomVal == 0) ? '' : this.roomData[this.roomVal].id, // 房间id
				sortField: this.sortField,
				sortOrder: this.sortOrder,
			};
			if (this.searchText && this.searchText.length > 0) {
				param.bedName = this.searchText;
			}
			this.spinning = true;
			this.$get(
				'/api/health/list',
				param,
				(res) => {
					this.spinning = false;
					if (res.code == 0) {
						if (res.data.records) {
							for (var i = 0; i < res.data.records.length; i++) {
								res.data.records[i].popoverVisible = false;
								res.data.records[i].sleepDuration = res.data.records[i].sleepDuration
									? this.$formaTime(res.data.records[i].sleepDuration)
									: '--';
								res.data.records[i].deepSleepDuration = res.data.records[i].deepSleepDuration
									? this.$formaTime(res.data.records[i].deepSleepDuration)
									: '0小时0分钟';
								res.data.records[i].lightSleepDuration = res.data.records[i].lightSleepDuration
									? this.$formaTime(res.data.records[i].lightSleepDuration)
									: '0小时0分钟';
								res.data.records[i].clearSleepDuration = res.data.records[i].clearSleepDuration
									? this.$formaTime(res.data.records[i].clearSleepDuration)
									: '0小时0分钟';
								res.data.records[i].outBedDuration = res.data.records[i].outBedDuration
									? this.$formaTime(res.data.records[i].outBedDuration)
									: '0小时0分钟';
								if (res.data.records[i].ahi) {
									res.data.records[i].ahi = res.data.records[i].ahi.toFixed(2);
								}
								if (
									res.data.records[i].diagnosisResults &&
									res.data.records[i].diagnosisResults == -1
								) {
									res.data.records[i].ahi = '-';
								}

								if (res.data.records[i].sleepDuration == '--') {
									//接口新增了没有健康报告的报告，所以都显示为--
									res.data.records[i].ahi = '--';
									res.data.records[i].outBedNum = '--';
									res.data.records[i].outBedDuration = '--';
									res.data.records[i].score = '--';
									res.data.records[i].turnOverIndex = '--';
									res.data.records[i].followTotal = '--';
									res.data.records[i].szhx = '--';
									res.data.records[i].sleepEff = '--';
								}
								if (res.data.records[i] && !res.data.records[i].followTotal && res.data.records[i].followTotal !== 0) {
									res.data.records[i].followTotal = '--';
								}
								if (res.data.records[i] && !res.data.records[i].turnOverNum && res.data.records[i].turnOverNum !== 0) {
									res.data.records[i].turnOverNum = '--';
								}
							}
							this.tableData = res.data.records;
							this.total = res.data.total;
						} else {
							this.tableData = [];
							this.total = 0;
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.spinning = true;
					this.$message.error('服务端发生异常');
				}
			);
		},
		// 分页
		pageChange(e) {
			console.log(e);
			this.pageNum = e;
			this.getTableData();
		},
		// 监听楼选择
		floorChange(e) {
			this.newSelectFloorIndex = e;

			if (e) {
				this.getLayerData();
				this.layerVal = '全部';
				this.roomVal = '全部';
				this.roomData = [{ name: '全部', id: '' }];
			} else {
				this.layerData = [{ name: '全部', id: '' }];
				this.layerVal = '全部';
				this.roomVal = '全部';
				this.roomData = [{ name: '全部', id: '' }];
			}
		},
		// 获取层下拉框数据
		getLayerData() {
			let needId = this.floorData[this.floorVal].id;
			this.$get(
				'/api/floor/getFloor/' + needId,
				{},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							res.data[0].id = '';
							this.layerData = res.data;
						} else {
							this.layerData = [{ name: '全部', id: '' }];
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		// 监听层选择
		layerChange(e) {
			this.newSelectLayerIndex = e;

			if (e) {
				this.getRoomData();
				this.roomVal = '全部';
			} else {
				this.roomVal = '全部';
				this.roomData = [{ name: '全部', id: '' }];
			}
		},
		// 监听房选择
		roomChange(e) {
			this.newSelectRoomIndex = e;
		},
		// 获取房间下拉框数据
		getRoomData() {
			// let layerVal = this.layerVal == '全部' ? '' : this.layerVal;
			this.$get(
				'/api/room/getRoom/' + this.layerData[this.layerVal].id,
				{},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							res.data[0].id = '';
							this.roomData = res.data;
						} else {
							this.roomData = [{ name: '全部', id: '' }];
						}
					} else {
						this.$message.error(res.msg);
						this.roomData = [];
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		// 筛选按钮
		screen() {
			this.getTableData();
		},
		// 筛选页面数据
		btnClick(val, date, num, type) {
			if (type == '1') {
				this.selectDateType = type
			} else if (type == '7') {
				this.selectDateType = type
			} else if (type == '3') {
				this.selectDateType = type
			} else {

			}
			this.activeType = val;
			this.activeDate = date;
			if (this.activeType > 2) {
				this.columns = morecolumns;
				this.activeDate = this.activeDates[0];
			} else {
				this.columns = columns;
			}
			this.getTableData();
		},
		btnClickNew(val, date, num, type) {
			if (type == '1') {
				this.selectDateType = type
			} else if (type == '7') {
				this.selectDateType = type
			} else if (type == '3') {
				this.selectDateType = type
			} else {

			}
			this.activeType = val;
			this.activeDate = date;
			if (this.activeType > 2) {
				this.columns = morecolumns;
				this.activeDate = '';
			} else {
				this.columns = columns;
			}
			this.getTableData();
		},
		changePageToData(path) {
			console.log(path);
			// this.$router.push('/dean/' + path);
			const { href } = this.$router.resolve({
				name: 'router-name',
				query: { id: 1 },
			});

			window.open(href, '_blank');
		},
		// 查看详情
		details(scope) {
			console.log(scope);
			this.$refs.healthy.details({
				// recordsData: scope,
				sn: scope.sn,
				bedId: scope.bedId,
				bedName: scope.bedName,
				activeType: this.activeType,
				activeDate: this.activeDate,
			});
		},
		// 获取单天详情数据

		// 二维码气泡
		QRCodeBtn(num, scope) {
			console.log(scope);
			if (scope.popoverVisible) {
				return;
			}
			let param = {
				baseUrl: '1',
				bedId: scope.bedId,
				type: this.activeType, // 1-昨天 2-前天 3-7天 4-30天
				date: this.activeDate,
			};
			this.loading1 = false;
			this.$get('/api/health/shareV1', param, (res) => {
				if (res.code == 0) {
					this.shareUrl = res.msg;
					// console.log(this.shareUrl);
				}
			});
			this.$nextTick(function () {
				this.bindQRCode1();
			});
		},
		// 分享
		shareBtn(scope) {
			console.log(scope)
			if (this.popoverVisible) {
				return;
			}


			let baseUrl = this.$store.state.baseUrl;
			let activeType = 1; //1日 2周 3月 4三月或六月
			if (this.activeType == 1) {
				activeType = 1;
			} else if (this.activeType == 3) {
				activeType = 2;
			} else if (this.activeType == 4) {
				activeType = 3;
			}
			let allParam =
				"?bedId=" +
				scope.bedId +
				"&activeType=" +
				activeType +
				"&date=" +
				this.activeDate;
			this.shareUrl = baseUrl + "/h5/#/index" + allParam;
			console.log(this.shareUrl);
			this.$nextTick(function () {
				this.bindQRCode2();
			});
			// let param = {
			//   baseUrl: '1',
			//   bedId: this.typeId,
			//   type: this.activeType, // 1-昨天 2-前天 3-7天 4-30天
			//   date: this.activeDate,
			// };

			// this.$get('/api/health/shareV1', param, (res) => {
			//   if (res.code == 0) {
			//     this.shareUrl = res.msg;
			//   }
			// });
			// this.$nextTick(function() {
			//   this.bindQRCode2();
			// });

		},
		// 生成二维码
		bindQRCode1: function () {
			setTimeout((e) => {
				new QRCode(this.$refs.qrCodeDiv, {
					text: this.shareUrl,
					width: 100,
					height: 100,
					colorDark: '#333333', //二维码颜色
					colorLight: '#ffffff', //二维码背景色
					correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
				});
				this.loading1 = true;
			}, 1000);
		},
		bindQRCode2: function () {
			setTimeout((e) => {
				new QRCode(this.$refs.qrCodeDiv, {
					text: this.shareUrl,
					width: 100,
					height: 100,
					colorDark: '#333333', //二维码颜色
					colorLight: '#ffffff', //二维码背景色
					correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
				});
				this.loading = false;
			}, 1000);

			setTimeout(() => {
				//判断二维码的距离实际顶部的距离
				var shareP = document.getElementsByClassName('ant-popover')[0];
				//console.log(shareP)
				this.popoverTop =
					parseInt(shareP.style.top.replace('px', '')) + this.scrollTop;
			}, 0);
		},
		// 导出
		exportData() {
			var st = '';
			if (this.activeType == 1 || this.activeType == 2) st = this.activeDate;
			else if (this.activeType == 3) st = this.activeDates[6];
			else st = this.activeDates[29];
			let param = {
				pageNum: this.pageNum, // 当前页
				pageSize: this.pageSize, // 每页默认20条
				startTime: st,
				endTime: this.activeDate,
				type: this.activeType, // 日期
				buildingId: this.floorVal, // 楼id
				floorId: this.layerVal == '全部' ? '' : this.layerVal, // 层id
				roomId: this.roomVal == '全部' ? '' : this.roomVal, // 房间id
				sortField: this.sortField,
				sortOrder: this.sortOrder,
			};
			if (this.activeType == 1 || this.activeType == 2) {
				this.$getExport('/api/health/exportv1', param, (res) => {
					const blob = new Blob([res]);
					//根据选择的是哪天大报告，去获取日期显示在名字上
					var fileName = this.activeDate + '健康数据.xlsx';
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				});
			} else {
				this.$getExport('/api/health/export', param, (res) => {
					const blob = new Blob([res]);
					//根据选择的是哪天大报告，去获取日期显示在名字上
					if (this.activeType == 3) {
						var fileName =
							this.getDay(-7, '-') +
							'-' +
							this.getDay(-1, '-') +
							'健康数据.xlsx';
					} else if (this.activeType == 4) {
						var fileName =
							this.getDay(-30, '-') +
							'-' +
							this.getDay(-1, '-') +
							'健康数据.xlsx';
					} else {
						var fileName = '健康数据.xlsx';
					}
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				});
			}
		},
		//获取日期
		getDay(num, str) {
			var today = new Date();
			var nowTime = today.getTime();
			var ms = 24 * 3600 * 1000 * num;
			today.setTime(parseInt(nowTime + ms));
			var oYear = today.getFullYear();
			var oMoth = (today.getMonth() + 1).toString();
			if (oMoth.length <= 1) oMoth = '0' + oMoth;
			var oDay = today.getDate().toString();
			if (oDay.length <= 1) oDay = '0' + oDay;
			return oYear + str + oMoth + str + oDay;
		},
		// 获取日历接口
		getHealthPageV1All() {
			let param2 = {
				bedId: this.typeId, // 当前页
			};
			this.$get(
				'/api/health/getHealthPageV1All',
				param2,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.effeDatesData = res.data.data;
							// console.log(this.effeDatesData);
							this.effeDates = [];
							var vdates = [];
							for (var i = 0; i < this.effeDatesData.length; i++) {
								for (var key in this.effeDatesData[i]) {
									if (key != 'reason') {
										vdates.push(key);
									}
								}
								if (this.effeDatesData[i].reason === '数据解析成功') {
									for (var key in this.effeDatesData[i]) {
										if (key != 'reason') {
											this.effeDates.push(key);
										}
									}
								}
							}
							this.invalidDates = [];
							for (var i = 0; i < this.activeDates.length; i++) {
								if (!vdates.includes(this.activeDates[i])) {
									this.invalidDates.push(this.activeDates[i]);
								}
							}
							// console.log("##", this.invalidDates);
							// console.log(this.effeDates);
						} else {
						}
					} else {
						this.$message.error(res.msg);
					}
					this.spinning = false;
				},
				(err) => {
					//console.log(err);
					this.spinning = false;
					this.$message.error('服务端发生异常');
				}
			);
		},
		getDayData(value) {
			for (var i = 0; i < this.effeDates.length; i++) {
				var m = parseInt(this.effeDates[i].slice(5, 7)) - 1;
				var d = parseInt(this.effeDates[i].slice(8, 10));
				if (value.month() == m && value.date() == d) return true;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.main::v-deep {
	margin-top: 20px;

	.ant-table-tbody>th>td {
		// padding: 16px 3px;
	}

	.ant-table-tbody>tr>td {
		padding: 12px;
	}

	.ant-card {
		padding: 12px 20px 0px 20px;
		border-radius: 8px;

		.ant-card-body {
			padding: 0;
		}
	}

	// 出问题可能在这里
	.ant-table table {
		border-radius: 16px 16px 0px 0px; 
		overflow: hidden;
	}

	.question-icon {
		width: 18px;
		font-size: 16px;
		display: inline-block;
		height: 18px;
		background-color: #1890ff;
		color: white;
		line-height: 18px;
		border-radius: 9px;
		position: relative;
		top: 1px;
		left: 0px;
	}

	.ant-table-thead>tr>th {
		background: rgba(255,255,255,0.5);;
		padding: 16px 5px;
	}

	.ant-table-row:nth-child(even) {
		background: rgba(255,255,255,0.5);;
	}
	.ant-table-row {
		background: rgba(255,255,255,0.7);;
	}

	.ant-table-row:hover {
		td {
			background:rgba(218, 227, 241, 1) !important;
		}
	}

	.topList {
		display: flex;
		justify-content: space-between;
		margin-bottom: 16px;

		.topleft {
			display: flex;

			.group {
				display: flex;
				margin-right: 20px;

				.title {
					font-size: 14px;
					color: #262626;
					line-height: 40px;
					margin-right: 10px;
				}
			}
		}
	}

	.operation {
		display: flex;
		align-items: center;
		justify-content: center;

		.tableBtn {
			cursor: pointer;
			color: rgba(74, 124, 232, 1);
		}

		.share {
			margin-left: 5px;

			.imgIcon {
				cursor: pointer;
				width: 16px;
				height: 16px;
			}
		}
	}
}

.report :global(.ant-descriptions-item-label) {
	background: white;
}

.health-title {
	display: -webkit-box;
	height: 40px;
	margin-top: 0px;
	margin-bottom: 0px;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.title {
		display: flex;

		width: 144px;
		height: 24px;
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #1F2635;
		position: relation;
	}

	.title::after {
		width: 4px;
		height: 20px;
		background: #1890FF;
		border-radius: 0px 2px 2px 0px;
		content: '';
		position: absolute;
		left: 0;
		top: 23px;
	}

	.shujuStyle {
		background: #DDEEFF;
		border-radius: 16px;
		padding: 6px 15px;
	}

	.saiBtn {
		display: flex;
		margin-left: 730px;
	}

	.button-date {
		background: #e6f7ff !important;
	}
	.hoverBtns:hover {
		background: #ffffff !important;
		color: #1890ff !important;
		border: 1px solid #1890ff !important;
	}

	.actives {
		background: #e6f7ff !important;
		color: #1890ff !important;
		border: 1px solid #e6f7ff !important;
	}

	.on {
		transition: color 0.3s, background 0.3s, border-color 0.3s;
		border-radius: 2px;
		padding: 5px 12px;
		cursor: pointer;
		margin-right: 10px;
		color: #262626;
		background: #ffffff;
		border: 1px solid #d9d9d9;
	}
}

.dateBtn {
	background: #ECF0F3 !important;
}

.topright {
	display: flex;
	justify-content: space-between;

	.hoverBtns:hover {
		color: #4A7CE8 !important;
		background: rgba(74,124,232,0.1) !important;
		border: 1px solid rgba(74,124,232,0.3) !important;
	}

	.actives {
		color: #4A7CE8 !important;
		background: rgba(74,124,232,0.1) !important;
		border: 1px solid rgba(74,124,232,0.3) !important;
	}

	.on {
		transition: color 0.3s, background 0.3s, border-color 0.3s;
		border-radius: 2px;
		cursor: pointer;
		margin-right: 10px;
		color: #5E6779;
		background: #ffffff;
		border: 1px solid #d9d9d9;
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		line-height: 20px;
		border-radius: 20px;
		display: flex;
		align-items: center;
		background: #ECF0F3;
		border-radius: 20px;
		border: 1px solid rgba(94,103,121,0.2);
	}
}

.shareBox {
	p {
		margin-bottom: 0;
		margin-top: 7px;
		display: flex;
		justify-content: space-between;
		align-items: center;

		span {
			margin-left: 4px;
		}
	}
}

.content {
	margin-top: -12px;

	.dataTitle {
		margin-top: 10px;
		display: flex;
		margin-bottom: 20px;
		position: relative;
		height: 200px;

		.dataContent {
			width: 100%;
			position: absolute;
			top: 0px;
			left: 0px;

			.dataTitleItem {
				display: flex;
				align-items: center;
				height: 30px;
				background: #e6f7ff;
				border-radius: 4px;
				padding: 2px 30px 2px 10px;
				margin-right: 10px;
				border-radius: 30px;
				width: auto;
				display: inline-block;
				position: absolute;
				top: 0px;
				left: 0px;

				.firstImg {
					text-align: center;
					margin-right: 15px;
					display: inline-block;

					.firstRect {
						width: 8px;
						height: 8px;
						border-radius: 4px;
						background-color: #1890ff;
						display: inline-block;
					}

					img {
						width: 36px;
						margin-bottom: 2px;
					}

					p {
						font-size: 10px;
						color: #1890ff;
						margin-bottom: 0;
						display: inline-block;
						margin-left: 7px;
					}
				}
			}

			.dataTitleItem0 {
				left: 12%;
				top: 40px;
			}

			.dataTitleItem1 {
				left: 62%;
				top: 30px;
			}

			.dataTitleItem2 {
				left: 8%;
				top: 100px;
			}

			.dataTitleItem3 {
				left: 67%;
				top: 70px;
			}

			.dataTitleItem4 {
				left: 72%;
				top: 110px;
			}
		}

		.text {
			color: #262626;
			font-size: 12px;
			margin-bottom: 0;
			display: inline-block;

			.large {
				font-size: 16px;
			}
		}
	}

	.myCharts {
		margin-bottom: 10px;
		position: relative;

		.bt {
			color: #262626;
			font-size: 12px;
			display: flex;
			align-items: center;

			img {
				width: 22px;
				margin-right: 5px;
			}
		}

		.rightList {
			list-style: none;
			color: #8c8c8c;
			font-size: 14px;
			position: absolute;
			top: 50%;
			right: 4%;
			z-index: 10000;
			transform: translate(-0, -40%);
			margin-bottom: 0;

			li {
				margin-bottom: 10px;

				.Dot {
					display: inline-block;
					width: 10px;
					height: 10px;
					border-radius: 50%;
					margin-right: 5px;
				}
			}

			li:last-child {
				margin-bottom: 0;
			}
		}
	}

	.myCharts:last-child {
		margin-bottom: 0;
	}
}

.table-empty {
	color: #8c8c8c;
	line-height: 20px;
	font-size: 16px;
	margin-top: 100px;
	margin-bottom: 100px;
	padding: 0 15px 0 15px;
	text-align: center;
}

.calDot {
	width: 7px;
	height: 7px;
	border-radius: 10px;
	background-color: #1890ff;
	display: inline-block;
	position: relative;
	top: -5px;
}




::v-deep .ant-select-selection--single {
	height: 40px;
	.ant-select-selection__rendered {
		line-height: 38px;
	}
}

::v-deep .ant-select-selection {
	background: #ECF0F3;
	border-radius: 20px;
	border: 1px solid rgba(94,103,121,0.2);
	box-shadow: unset !important;
}

::v-deep .ant-select-selection:hover {
	background: rgba(74,124,232,0.1);
	border-radius: 20px;
	border: 1px solid rgba(74,124,232,0.3);
	box-shadow: unset !important;
}

::v-deep .ant-select-selection:active {
	background: rgba(74,124,232,0.1);
	border-radius: 20px;
	border: 1px solid rgba(74,124,232,0.3);
	box-shadow: unset !important;
}


::v-deep .ant-select-selection:focus {
	background: rgba(74,124,232,0.1);
	border-radius: 20px;
	border: 1px solid rgba(74,124,232,0.3);
	box-shadow: unset !important;
}

::v-deep .ant-select-open {
	.ant-select-selection {
		background: rgba(74,124,232,0.1) !important;
		border: 1px solid rgba(74,124,232,0.3) !important;
		.ant-select-selection-selected-value {
			color: rgba(74, 124, 232, 1) !important;
		}
		.ant-select-arrow {
			color: rgba(31, 38, 53, 0.5);
		}
	}
	.ant-select-selection:hover {
		background: rgba(74,124,232,0.1) !important;
		border: 1px solid rgba(74,124,232,0.3) !important;
		.ant-select-selection-selected-value {
			color: rgba(74, 124, 232, 1) !important;
		}
		.ant-select-arrow {
			color: rgba(31, 38, 53, 0.5);
		}
	}
}

::v-deep .my-a-select-normal {
	.ant-select-selection {
		background: #ECF0F3;
		border: 1px solid rgba(94,103,121,0.2);
		.ant-select-selection-selected-value {
			color: rgba(94, 103, 121, 1);
		}
		.ant-select-arrow {
			color: rgba(31, 38, 53, 0.5);
		}
	}
	.ant-select-selection:hover {
		background: rgba(74,124,232,0.1);
		border: 1px solid rgba(74,124,232,0.3);
		.ant-select-selection-selected-value {
			color: rgba(74, 124, 232, 1);
		}

		.ant-select-arrow {
			color: rgba(31, 38, 53, 0.5);
		}
	}
}

::v-deep .my-a-select-high-light {
	.ant-select-selection {
		background: rgba(74,124,232,0.1);
		border: 1px solid rgba(74,124,232,0.3);
		.ant-select-selection-selected-value {
			color: rgba(74, 124, 232, 1);
		}
		.ant-select-arrow {
			color: rgba(31, 38, 53, 0.5);
		}
	}
	.ant-select-selection:hover {
		background: rgba(74,124,232,0.1);
		border: 1px solid rgba(74,124,232,0.3);
		.ant-select-selection-selected-value {
			color: rgba(74, 124, 232, 1);
		}
		.ant-select-arrow {
			color: rgba(31, 38, 53, 0.5);
		}
	}
}








::v-deep .ant-pagination-item {
	background: #ECF0F3;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid #ECF0F3;
}

::v-deep .ant-pagination-item:hover {
	background: #DFE8FC;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid #DFE8FC;
}

::v-deep .ant-pagination-item-active {
	background: #ECF0F3;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid rgba(74,124,232,0.5);
}

::v-deep .ant-pagination-item-link {
	background: #ECF0F3;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 0px solid #ECF0F3;
}

::v-deep .ant-pagination-item-link:hover {
	background: #DFE8FC;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid #DFE8FC;
}

::v-deep .ant-pagination-disabled .ant-pagination-item-link {
	background: #ECF0F3;
	border-radius: 10px;
	border: 1px solid rgba(202,205,217,0.5);
	box-shadow: unset;
}







.my-select-date:hover {
	.my-select-date-input {
		background: rgba(74,124,232,0.1); 
		border: 1px solid rgba(74,124,232,0.3);
	}
	.my-select-date-input-img {
		background: url('../../assets/icon_common_select_date_icon_2.png') no-repeat no-repeat;
		background-size: contain;
	}
	.my-select-date-input-text {
		color: rgba(74, 124, 232, 1);
	}
}

.my-select-date-1 {
	.my-select-date-input {
		background: #ECF0F3;
		border: 1px solid rgba(94,103,121,0.2);
	}
	.my-select-date-input-img {
		background: url('../../assets/icon_common_select_date_icon_1.png') no-repeat no-repeat;
		background-size: contain;
	}
	.my-select-date-input-text {
		color: rgba(94, 103, 121, 1);
	}
}

.my-select-date-2 {
	.my-select-date-input {
		background: rgba(74,124,232,0.1); 
		border: 1px solid rgba(74,124,232,0.3);
	}
	.my-select-date-input-img {
		background: url('../../assets/icon_common_select_date_icon_2.png') no-repeat no-repeat;
		background-size: contain;
	}
	.my-select-date-input-text {
		color: rgba(74, 124, 232, 1);
	}
}


::v-deep .ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters > *:not(.ant-table-column-sorter) {
	color: #5E6779 !important;
	font-size: 14px;
	font-weight: 600;
}

.searchBedNameInputContent {

	input::placeholder {
		color: rgba(94, 103, 121, 0.3);
	}

}

.searchBedNameInputContent_hover {

	input::placeholder {
		color: rgba(74, 124, 232, 0.3);
	}

	background: rgba(74,124,232,0.1);
	border: 1px solid rgba(74,124,232,0.3) !important;

	.searchBedNameInputContentSearchImage {
		background: url("../../assets/icon_health_data_search_input_icon_2.png") no-repeat;
		background-size: cover;
	}


}

.searchBedNameInputContent_edit {

	input::placeholder {
		color: rgba(94, 103, 121, 0.3);
	}

	background: #FFFFFF;
	border: 1px solid rgba(74, 124, 232, 1) !important;

}

.searchBedNameInputContentSearchImage {
	background: url("../../assets/icon_health_data_search_input_icon_1.png") no-repeat;
	background-size: cover;
}

.searchBedNameInputContentSearchImage:hover {
	background: url("../../assets/icon_health_data_search_input_icon_2.png") no-repeat;
	background-size: cover;
}

</style>


<style>
.my-el-date-picker-popper {
	border-radius: 8px;
	.el-date-table td.current:not(.disabled) span {
		background: rgba(74, 124, 232, 1);
	}
	.el-date-table td.available:hover {
		span {
			background: rgba(74, 124, 232, 0.1);
		}
	}
	.el-date-table th {
		color: rgba(94, 103, 121, 0.5);
	}
	.el-date-table td.next-month, .el-date-table td.prev-month {
		color: rgba(94, 103, 121, 0.14);
	}
	.popper__arrow {
		opacity: 0 !important;
	}
	.el-date-table td.disabled div {
		background-color: #FFFFFF00 !important;
		color: rgba(94, 103, 121, 0.14) !important;
	}
}

.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled) {
	background: rgba(74, 124, 232, 0.1) !important;
	color: rgba(74, 124, 232, 1) !important;
}

.ant-select-dropdown {
	background: #FFFFFF;
	box-shadow: 0px 0px 10px 0px rgba(94,103,121,0.2);
	border-radius: 8px;
}

.ant-select-dropdown-menu-item-selected {
	background: rgba(74, 124, 232, 0.1) !important;
	color: rgba(74, 124, 232, 1) !important;
}

.ant-select-dropdown-menu-item {
	font-weight: '400' !important;
}

.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {
	background-color: #FFFFFF00;
}

</style>